exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".evaluationBox img{max-width:45px}.evaluationBox .btn{margin-left:5px;margin-top:0;padding:0}.evaluationBox .btn-link:focus{outline:none}.evaluationBox .not-selected{opacity:.5}.evaluationBox .not-selected:hover{opacity:1}.evaluationBox .autoGraded:hover{filter:none;-webkit-filter:none}.evaluationBox .autoGraded{filter:hue-rotate(179deg) drop-shadow(#0082c8 0 0 4px);transition:opacity 1s}.evaluationBox .autoGraded.glowOut{opacity:.5}.evaluationBox .autoGraded.glowOut:hover{opacity:1}.evaluationBox .gradeMeNotice{margin-top:10px;float:right;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/evaluations/evaluation_box.scss
// module id = 913
// module chunks = 0